<template>
    <td-dialog :title="title" :before-close="extendDialogClose" :visible.sync="dialogExtendVisible" :width="formLabelWidth" :close-on-click-modal="false" :close-on-press-escape="false" top="18vh">
        <el-form :model="formExtendInfo" ref="formExtendInfo" :rules="rules">
            <el-row>
                <el-col :span="24">
                    <el-form-item :label="$t('common.EXTENDNAME')" :label-width="formLabelWidth" prop="sName">
                        <td-input v-model="formExtendInfo.sName" :maxlength="50"></td-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item :label="$t('common.EXTENDTYPE')" :label-width="formLabelWidth">
                        <el-select
                            v-model="formExtendInfo.sExtendType"
                            :placeholder="$t('common.PLEASE_SELECT')"
                            @change="
                                val => {
                                    handleSelectChange(val);
                                }
                            "
                            style="width:200px;"
                        >
                            <el-option v-for="(type, i) in this.extendTypes" :key="i" :label="type.label" :value="type.key"> </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row v-show="showParamsText">
                <el-form-item :label="$t('common.EXTENDDATA')" :label-width="formLabelWidth" prop="selectParams">
                    <td-input type="textarea" v-model="formExtendInfo.sParam" :maxlength="200"></td-input>
                </el-form-item>
                <el-form-item :label-width="formLabelWidth"> {{ $t('common.EXTENDDATATIP') }}</el-form-item>
            </el-row>
            <el-row v-show="showParamsSelect">
                <el-col :span="24">
                    <el-form-item :label="$t('common.EXTENDDATA')" :label-width="formLabelWidth">
                        <el-select v-model="formExtendInfo.sParam" :placeholder="$t('common.PLEASE_SELECT')" style="width:200px;">
                            <el-option v-for="(type, i) in this.inputTypes" :key="i" :label="type.label" :value="type.key"> </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item :label="$t('common.ORDER')" :label-width="formLabelWidth" prop="iOrder">
                        <!-- <td-input v-model="formExtendInfo.iOrder" ></td-input> -->
                        <td-input-number v-model="formExtendInfo.iOrder" :min="1" :max="100"></td-input-number>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item :label="$t('common.EXTENDMODULE')" :label-width="formLabelWidth">
                        <el-select v-model="formExtendInfo.sModuleId" :placeholder="$t('common.PLEASE_SELECT')" style="width:200px;">
                            <el-option v-for="(item, i) in this.moudleData" :key="i" :label="item.sModuleName" :value="item.sId"> </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <!-- 必填校验 -->
            <el-row>
                <el-form-item :label="$t('common.REQUIRED_VERIFICATION')" :label-width="formLabelWidth">
                    <td-radio v-model="formExtendInfo.isRequired" :options="optionsRadio"></td-radio>
                </el-form-item>
            </el-row>
            <!-- 校验规则 -->
            <el-row>
                <el-form-item :label="$t('common.CHECK_RULE')" :label-width="formLabelWidth">
                    <td-select v-model="formExtendInfo.checkRule" :placeholder="$t('common.PLEASE_SELECT')" :options="ruleOption" keys="sRegex" text="sName" :allowCreate="true"></td-select>
                </el-form-item>
            </el-row>
            <!-- 校验提示 -->
            <el-row>
                <el-form-item :label="$t('common.CHECK_RULE_TIPS')" :label-width="formLabelWidth">
                    <td-input v-model="formExtendInfo.checkTips"></td-input>
                </el-form-item>
            </el-row>
        </el-form>
        <span slot="footer">
            <td-button type="primary" @click="submitForm('formExtendInfo')" :loading="loading">{{ $t('common.SAVE') }}</td-button>
            <td-button type="button" @click.native="extendDialogClose">{{ $t('common.CANCEL') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
import resourceApi from '../assets/api.js';
export default {
    props: ['title', 'dialogExtendVisible', 'editItem', 'isAddData', 'moudleData', 'sysFlg', 'curModule', 'maxExtendOrder'],
    created() {
        this.formExtendInfo.sModuleId = this.curModule;
        // 为编辑状态则进行初始化数据
        if (!this.isAddData) {
            this.initEditData();
        } else {
            // 默认新增排序字段为当前数据库中最大的排序字段值
            this.formExtendInfo.iOrder = this.maxExtendOrder;
        }
        this.initCheckRule();
    },
    // 定义变量
    data() {
        return {
            /* 必填数据项 */
            optionsRadio: [
                {
                    label: this.$t('common.YES'),
                    value: 1
                },
                {
                    label: this.$t('common.NOT'),
                    value: 0
                }
            ],
            /* 校验规则数据项 */
            ruleOption: [],
            extendTypes: [
                {
                    key: 'input',
                    label: this.$t('common.INPUT')
                },
                {
                    key: 'combobox',
                    label: this.$t('common.COMBOBOX')
                },
                {
                    key: 'checkbox',
                    label: this.$t('common.CHECKBOX')
                },
                {
                    key: 'checkboxgroup',
                    label: this.$t('common.CHECKBOXGROUP')
                },
                {
                    key: 'radio',
                    label: this.$t('common.RADIO')
                },
                {
                    key: 'date',
                    label: this.$t('common.DATE')
                }
            ],
            inputTypes: [
                {
                    key: 'input',
                    label: this.$t('common.INPUT')
                },
                {
                    key: 'textarea',
                    label: this.$t('common.TEXTAREA')
                },
                {
                    key: 'password',
                    label: this.$t('common.PASSWORD_INPUT')
                }
            ],
            // Extend表单信息
            formExtendInfo: {
                sName: '',
                sExtendType: '',
                sParam: '',
                iOrder: '',
                sSysFlg: '',
                sModuleId: '',
                //是否必填
                isRequired: 1,
                //校验规则
                checkRule: '',
                //校验提示
                checkTips: ''
            },
            formLabelWidth: '30%',
            showParamsText: false,
            showParamsSelect: false,
            loading: false,
            // 对表单进行数据验证
            rules: {
                sName: [
                    { required: true, message: this.$t('error.ERROR_CAPTION_NULL'), trigger: 'blur' },
                    { min: 1, max: 50, message: this.$t('error.ERROR_CAPTION_MAX_LENGTH'), trigger: 'blur' },
                    {
                        pattern: this.$regex.CAPTION_RULE,
                        message: this.$t('error.ERROR_CAPTION_ILLEGAL')
                    }
                ],
                iOrder: [
                    { required: true, message: this.$t('error.ERROR_ORDER_NULL'), trigger: ['blur', 'change'] }
                    // { pattern: this.$regex.ONLY_NUMBER,
                    //     message: this.$t('error.ERROR_ORDER_ILLEGAL'),
                    //     trigger: ['blur', 'change']}
                    // { required: true, message: this.$t('regex.PLEASE_ENTER_NAME_AlARM_LEVEL'), trigger: 'blur' },
                    // { min: 1, max: 12, message: this.$t('regex.PLEASE_ENTER_NAME_AlARM_LEVEL') },
                    // { pattern: this.$regex.ONLY_NUMBER, message: this.$t('regex.NAME_ILLEGAL_AlARM_LEVEL') }
                ]
                // ,
                // selectParams: [
                //     { required: true, message: this.$t('error.ERROR_CAPTION_NULL'), trigger: 'blur' },
                //     { min: 1, max: 50, message: this.$t('error.error_caption_max_length'), trigger: 'blur' },
                //     { pattern: this.$regex.CAPTION_RULE, message: this.$t('error.ERROR_CAPTION_ILLEGAL')}
                //     // { required: true, message: this.$t('error.ERROR_ORDER_NULL'), trigger: ['blur', 'change'] },
                //     // { pattern: this.$regex.SELECT_PARAMS,
                //     //     message: this.$t('error.ERROR_ORDER_ILLEGAL'),
                //     //     trigger: ['blur', 'change']}
                // ]

                //,
                // iType: [
                //     { required: true, message: this.$t('error.ERROR_TYPE_NULL'), trigger: 'change' }
                // ],
                // iPort: [
                //     { required: true, message: this.$t('error.ERROR_PORT_NULL'), trigger: 'blur' }
                // ],
                // sUsername: [
                //     { required: true, message: this.$t('error.ERROR_USERNAME_NULL'), trigger: 'blur' }
                // ],
                // sPassword: [
                //     { required: true, message: this.$t('error.ERROR_PASSWORD_NULL'), trigger: 'blur' },
                //     { min: 1, max: 100, message: this.$t('error.ERROR_PASSWORD_MAX_LENGTH'), trigger: 'blur' }
                // ]
            }
        };
    },
    // 定义并实现方法体
    methods: {
        /* 初始化校验规则 */
        initCheckRule() {
            resourceApi.getRegexList(null, response => {
                if (response.status !== this.$common.login.RESPONSE_STATUS) {
                    this.$message({
                        showClose: true,
                        message: response.data.statusMessage,
                        type: 'error'
                    });
                    this.$log.error('dialogExtendInfo/getDictValuesByType', response);
                    return;
                }
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({
                        showClose: true,
                        message: response.data.statusMessage,
                        type: 'error'
                    });
                    this.$log.error('dialogExtendInfo/getDictValuesByType', response.data.message);
                    return;
                }
                this.ruleOption = response.data.content;
            });
        },
        // 初始化编辑数据
        initEditData() {
            this.formExtendInfo.sName = this.editItem.sName;
            this.formExtendInfo.sExtendType = this.editItem.sExtendType;
            this.formExtendInfo.sParam = this.editItem.sParam;
            this.formExtendInfo.iOrder = this.editItem.iOrder;
            this.formExtendInfo.sModuleId = this.editItem.sModuleId;
            this.formExtendInfo.isRequired = this.editItem.iRequired;
            this.formExtendInfo.checkRule = this.editItem.sCheckRule;
            this.formExtendInfo.checkTips = this.editItem.sCheckTips;
            if (this.formExtendInfo.sExtendType === 'input') {
                this.showParamsSelect = true;
                this.showParamsText = false;
            } else if (this.formExtendInfo.sExtendType === 'combobox' || this.formExtendInfo.sExtendType === 'checkboxgroup' || this.formExtendInfo.sExtendType === 'radio') {
                this.showParamsText = true;
                this.showParamsSelect = false;
            }
        },
        checkChange(item, node, self) {
            if (node === true) {
                // 点击未选中复选框
                this.editCheckId = item.sId;
                this.$refs.tree.setCheckedKeys([item.sId]);
            } else {
                if (this.editCheckId === item.sId) {
                    // 点击已选中复选框，保证至少一个选中
                    this.$refs.tree.setCheckedKeys([item.sId]);
                }
            }
        },
        // 提交数据
        submitForm(formName) {
            this.$refs[formName].validate(valid => {
                // console.log(formName)
                // return
                if (valid) {
                    this.loading = true;
                    let content = {
                        sName: this.formExtendInfo.sName,
                        sExtendType: this.formExtendInfo.sExtendType,
                        sParam: this.formExtendInfo.sParam,
                        iOrder: this.formExtendInfo.iOrder,
                        sSysFlg: this.sysFlg,
                        sModuleId: this.formExtendInfo.sModuleId,
                        iRequired: this.formExtendInfo.isRequired,
                        sCheckRule: this.formExtendInfo.checkRule,
                        sCheckTips: this.formExtendInfo.checkTips
                    };
                    let successMsg = this.$t('common.ADD_SUCCESS');
                    if (!this.isAddData) {
                        content.sid = this.editItem.sId;
                        successMsg = this.$t('common.MODIFY_SUCCESS');
                    }
                    resourceApi.insertExtendInfo(JSON.stringify(content), response => {
                        if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                            this.$message.error({ showClose: true, message: response.data.statusMessage });
                            this.$log.error('extend/insertExtendInfo', response.data.statusMessage);
                            return;
                        }
                        this.$message.success({ showClose: true, message: successMsg });
                        this.extendDialogClose();
                        this.$emit('submit');
                    });
                }
            });
        },
        // 关闭窗口之前需要调用的方法
        extendDialogClose() {
            this.$emit('extendDialogClose');
            this.$refs['formExtendInfo'].resetFields(); // 重置表单数据
        },
        handleSelectChange(val) {
            this.formExtendInfo.sParam = '';
            if (val === 'input') {
                this.showParamsSelect = true;
                this.showParamsText = false;
            } else if (val === 'combobox' || val === 'checkboxgroup' || val === 'radio') {
                this.showParamsText = true;
                this.showParamsSelect = false;
            } else {
                this.showParamsText = false;
                this.showParamsSelect = false;
            }
        }
    }
};
</script>
<style>
.btnStyle {
    text-align: center;
}
.el-dialog__header {
    background-color: #266eb1;
}
.el-dialog__headerbtn .el-dialog__close {
    color: #000 !important;
}
.custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
}
</style>
